//提前加载图片
const preloadImages = () => {
    for(let i=18;i<26;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/12k_box3_${i}.avif?v=1752807004`;
    }
};
preloadImages()

if(window.innerWidth>750){
    var wFlag=true
}else{
    wFlag=false
}


$(()=>{
    setTimeout(() => {
        $('.box1_title').addClass('showup')
    }, 200);

    ScrollTrigger.create({
        trigger:'.box4',
        start:'top center',
        end:'+=40%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box3_item2 div:nth-child(1)',{x:'-60%',opacity:0})
            .from('.box3_item2 div:nth-child(3)',{x:'50%',opacity:0},'<')
            .from('.box3_item2 div:nth-child(2)',{opacity:0},'-=50%')
    })

    ScrollTrigger.create({
        trigger:'.box4',
        start:'top top+=5%',
        end:'+=50%',
        scrub:1,
        animation:gsap.timeline()
            .to('.box3_item2',{y:'-30%',scale:0.55,opacity:0})
            .from('.box3_img',{opacity:0},'-=50%')
            .from('.box3_title2',{opacity:0,y:'2rem'},'<')
            .from('.box4_bg',{opacity:0},'<')
    })

    ScrollTrigger.create({
        trigger:'.box4',
        start:'top top+=5%',
        end:'+=70%',
        pin:true,
        //markers:true,
    })

    showUp('.box3_title')

    ScrollTrigger.create({
        trigger:'.box3',
        start:'top center',
        end:'+=40%',
        scrub:1,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 7);
            $('.box3_img1').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/12k_box3_${index+18}.avif?v=1752807004`)
            $('.box3_right div:nth-child(2) img').toggleClass('box3_active',index>2)
        }
    })

    showUp('.box5_title')

    ScrollTrigger.create({
        trigger:'.box5',
        start:'top top+=5%',
        end:'+=120%',
        scrub:1,
        pin:true,
        animation:gsap.timeline()
            .from('.box5_img img:first-child',{y:'-60rem'})
            .to('.box5_title div span:nth-child(1)',{opacity:0})
            .to('.box5_title div span:nth-child(2)',{opacity:1},'<')
            .from('.box5_icon',{y:'2rem',opacity:0},'<')
            .to('.box5_img',{scale:1.2},'<')
    })

    showUp('.box6_title')

    showUp('.box6_items div:first-child p')

    ScrollTrigger.create({
        trigger:'.box6_items div:first-child p',
        start:'top bottom-=20%',
        end:'+=10%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 10);
            if(index>2){
                $('.box6_items div:first-child p').css({opacity:1,y:'0'})
                // 执行一次
                if(sl_flag){
                    startSl()
                    sl_flag=false;
                }
            }else{
                // 重置
                sl_flag=true,sl1 = 165,sl2 = 15,sl3=0
                $('.box6_items div:first-child p').css({opacity:0,y:'2rem'})
            }
        }
    })

    var sl1 = 165,sl2 = 15,sl3=0, sl_flag=true,flag_sl;
    function startSl(){
        flag_sl =  setInterval(num,30)
    }
    function num(){
        sl1++;
        sl2++;
        sl3++;
        $(`.box6_items div:first-child p span:nth-child(1) c num`).text(`${sl1}%`)
        $(`.box6_items div:first-child p span:nth-child(2) c num`).text(`${sl2}%`)
        $(`.box6_items div:first-child p span:nth-child(3) c num`).text(`${sl3}%`)
        if(sl1 > 199){
            clearInterval(flag_sl);
        }
    }

    // showUp('.box6_items div:nth-child(2) p')

    // showUp('.box6_items div:nth-child(3) p')

    showUp('.box7_title')

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top center',
            end:'+=20%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box7_items div',{x:0})
        })
    }else{
        new Swiper('.box8Swiper', {
            autoplay: true,
            loop:true,
            slidesPerView: 1.25,
            centeredSlides: true,
        })
    }

    showUp('.box8_title')

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box8',
            start:'top center',
            end:'+=20%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box8Swiper .swiper-wrapper .swiper-slide',{x:0})
        })
    }
    
    showUp('.box9_title')

    ScrollTrigger.create({
        trigger:'.box9',
        start:'top center',
        end:'+=20%',
        scrub:1,
        animation:gsap.timeline()
            .to('.box9_items div',{x:0})
    })

    if(!wFlag){
        new Swiper('.box10Swiper', {
            //autoplay: true,
            //loop:true,
            slidesPerView: 1.25,
            centeredSlides: true,
        })
    }

    showUp('.box10_title')

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box10',
            start:'top bottom-=20%',
            end:'+=160%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box10_item',{y:'2rem',opacity:0,stagger:0.2})
        })
    }

    showUp('.box11_content')

    new Swiper('.box12Swiper', {
        autoplay: true,
        clickable :true,
        pagination: {
            el: '.box12Swiper-pagination',
        },
    })
})